import React from "react";
import { Outlet } from "react-router-dom";

const AdminStyleProvider = () => {
  return (
    <>
      <link rel="stylesheet" type="text/css" href="/css/admin.css" />
      <Outlet />
    </>
  );
};

export default AdminStyleProvider;
